
	import { Component, Vue } from 'vue-property-decorator';
	import aps from '@/HostApp/store/ApsModules/ApsModule';
	import { serverProps } from '@/Common/Environment/const';
	import helpCenterServiceModule from '@/HostApp/services/HelpCenterService/HelpCenterServiceModule';

	@Component({})
	export default class ContentHeader extends Vue {
		protected state: APS.IServerProps = serverProps;

		protected get isAnonymousContext(): boolean {
			return this.state.isAnonymousContext;
		}

		protected get titleComputedStyle(): Partial<CSSStyleDeclaration> {
			const { isVue, popup } = aps.context._view;
			const isWizardActive = aps.wizard.active;

			const dontShowPadding = isVue && !popup && !isWizardActive;
			return {
				paddingBottom: dontShowPadding ? '0' : '20px'
			};
		}

		protected get breadcrumbs(): APS.IBreadcrumbs {
			return this.state.breadcrumbs;
		}

		protected get viewParams(): APS.IViewParams {
			return this.state.viewParams;
		}

		protected get isXSClientType(): boolean {
			return this.state.isXSClientType;
		}

		protected get error404(): APS.IError404 {
			return this.state.error404;
		}

		protected get hasBreadcrumbs(): boolean {
			return this.breadcrumbs.hasBreadcrumbs;
		}

		protected get label(): string {
			return this.breadcrumbs.label;
		}

		protected get isHelpCenterEnabled(): boolean {
			return helpCenterServiceModule.isEnabled || false;
		}

		protected get helpCenterArticleTitle(): string {
			return helpCenterServiceModule.articleTitle;
		}

		protected openHelpCenter(): void {
			helpCenterServiceModule.setIsHelpCenterOpened(true);
		}
	}
